import { FormGroup } from '@angular/forms';
import { ForwardPointsField, Leg } from '@approot/models';
import { Utilities } from '@approot/utilities';
import { DEFAULT_DECIMAL_PLACES } from '../leg.component';
import { getAttributeControlFromKey } from './leg-attribute-utilities';

export function setBidAskValue(
  form: FormGroup,
  leg: Leg,
  ctrlName: ForwardPointsField,
  val: number | string,
  dp: number,
  emitEvent = false
) {
  const cleanValue = Utilities.cleanFormattedNumeric(val);
  if (cleanValue == null || isNaN(cleanValue)) {
    return;
  }
  const ctrl = form.get(ctrlName);
  const newVal = cleanValue.toFixed(dp);
  if (newVal !== ctrl.value) {
    ctrl.setValue(newVal, { emitEvent });
  }
}
